import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Stack,
  Select,
  MenuItem,
  FormHelperText,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import EditDialog from "../../../Components/Common/EditDialog";
import { get, post } from "../../../utils/api";
import SelectField from "../../../Components/Masters/SelectField";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const AddGhg = ({
  inputData,
  setAddData,
  addData,
  setsnackOpen,
  handleClose,
}) => {
  const [errors, setErrors] = useState({});

  let currentYearValue = new Date().getFullYear();

  const initialState = {
    reportingYear: currentYearValue,
    reportingPeriod: "",
    typeOfReport: "Consolidated",
    facility: "",
  };
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();
  const startYear = currentYear - 5;
  const years = Array.from({ length: 6 }, (_, i) => startYear + i).reverse();

  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);

  const [filteredYears, setFilteredYears] = useState(years);
  const [disableFromYear, setDisableFromYear] = useState("");
  const [disableToYear, setDisableToYear] = useState("");
  const [facilities, setFacility] = useState([]);

  const fetchFacilities = async () => {
    try {
      const response = await get(`/master/getAllFacility`);
      let arr = response?.data?.data.map((item) => ({
        value: item?._id,
        label: item?.facilityName,
      }));

      setFacility(arr);
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  };
  console.log("facility", facilities);

  useEffect(() => {
    fetchFacilities();
  }, []);

  const validateForm = () => {
    const newErrors = {};

    if (formData?.reportingYear === "") {
      newErrors["reportingYear"] = "Reporting Year is required";
    }

    if (formData?.reportingPeriod === "") {
      newErrors["reportingPeriod"] = "Reporting Period is required";
    }

    if (formData?.typeOfReport === "") {
      newErrors["typeOfReport"] = "Report Type is required";
    }

    if (formData?.typeOfReport === "Facility" && formData?.facility === "") {
      newErrors["facility"] = "Facility is required";
    }

    setErrors(newErrors);
    console.log(newErrors, "new1");
    return Object.keys(newErrors).length === 0;
  };

  const [loading, setLoading] = useState(false);

  const Save = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      const response = await post("/ghg-report/create", formData);
      const message = response?.data?.message;
      setsnackOpen({
        open: true,
        message:
          message || "Report generation is in progress, Check after 10 mins.",
        severity: "success",
      });
      setFormData(initialState);
      handleClose();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessages = error.response.data.errors
          .map((err) => err.msg)
          .join(", ");
        setsnackOpen({
          open: true,
          message: errorMessages,
          severity: "error",
        });
      } else {
        setsnackOpen({
          open: true,
          message: error.message || "An error occurred while saving the data.",
          severity: "error",
        });
      }
    } finally {
      setLoading(false); // Stop loading after response (success or error)
    }
  };

  const handleExitAgree = () => {
    setErrors({});
    setEditDialog(false);
    setFormData(initialState);
    setFormData2(initialState); // Reset form data to initial state
    handleClose();
  };

  const handleExit = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData[key] === formData2[key]
    );
    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedFormData = {
      ...formData,
      [name]: value,
    };

    // Parse all values we might need
    const fromMonth = parseInt(
      name === "fromMonth" ? value : formData.fromMonth,
      10
    );
    const fromYear = parseInt(
      name === "fromYear" ? value : formData.fromYear,
      10
    );
    const toMonth = parseInt(name === "toMonth" ? value : formData.toMonth, 10);
    const toYear = parseInt(name === "toYear" ? value : formData.toYear, 10);

    // --- Disable From Year if fromMonth > currentMonth and same year
    if (name === "fromMonth") {
      if (fromYear === currentYear && parseInt(value) > currentMonth) {
        setDisableFromYear(currentYear);
        updatedFormData.fromYear = "";
      } else {
        setDisableFromYear("");
      }
    }

    // --- Disable To Year if toMonth > currentMonth and same year
    if (name === "toMonth") {
      if (toYear === currentYear && parseInt(value) > currentMonth) {
        setDisableToYear(currentYear);
        updatedFormData.toYear = "";
      } else {
        setDisableToYear("");
      }
    }

    // --- Validate: From date must not be in future
    if (
      (name === "fromMonth" || name === "fromYear") &&
      fromMonth &&
      fromYear &&
      (fromYear > currentYear ||
        (fromYear === currentYear && fromMonth > currentMonth))
    ) {
      updatedFormData.fromMonth = "";
      updatedFormData.fromYear = "";
      setErrors((prev) => ({
        ...prev,
        fromMonth: "From date cannot be in the future.",
        fromYear: "From date cannot be in the future.",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        fromMonth: "",
        fromYear: "",
      }));
    }

    // --- Validate: To date must not be less than From date
    if (
      (name === "toMonth" || name === "toYear") &&
      fromMonth &&
      fromYear &&
      toMonth &&
      toYear &&
      (toYear < fromYear || (toYear === fromYear && toMonth < fromMonth))
    ) {
      updatedFormData.toMonth = "";
      updatedFormData.toYear = "";
      setErrors((prev) => ({
        ...prev,
        toMonth: "To date cannot be earlier than From date.",
        toYear: "To date cannot be earlier than From date.",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        toMonth: "",
        toYear: "",
      }));
    }

    // --- Update final state
    setFormData(updatedFormData);
  };

  const reportingPeriodList = [
    {
      value: "FiscalYear",
      label: "Fiscal Year",
    },
    { value: "CalendarYear", label: "Calendar Year" },
  ];

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{ width: "26rem", maxWidth: "100%", height: "100%" }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleExit} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          Generate GHG Report
        </Typography>
        <Stack spacing={1}>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Reporting Year
            </Typography>
            <SelectField
              name="reportingYear"
              value={formData?.reportingYear}
              handleChange={handleChange}
              options={filteredYears}
              errors={errors?.["reportingYear"] || ""}
              defaultValue="Year"
            />
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Reporting Period
            </Typography>
            <TextField
              select
              name="reportingPeriod"
              value={formData.reportingPeriod || "Select Period"}
              onChange={handleChange}
              size="small"
              fullWidth
              error={Boolean(errors?.reportingPeriod)}
              helperText={errors?.reportingPeriod || ""}
            >
              <MenuItem value="Select Period" disabled>
                Select Period
              </MenuItem>
              {reportingPeriodList.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          {/* <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              To
            </Typography>
            <Stack direction="row" spacing={2}>
              <Box sx={{ flex: 1 }}>
                <SelectField
                  name="toMonth"
                  value={formData?.toMonth}
                  handleChange={handleChange}
                  label="Month"
                  field="toMonth"
                  errors={errors?.["toMonth"] || ""}
                  defaultValue="Month"
                  options={monthlist}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <SelectField
                  name="toYear"
                  value={formData?.toYear}
                  handleChange={handleChange}
                  options={filteredYears}
                  errors={errors?.["toYear"] || ""}
                  defaultValue="Year"
                  menuDisable={disableToYear}
                />
              </Box>
            </Stack>
          </Box> */}
        </Stack>

        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: 1, mt: 1 }}
          >
            Type
          </Typography>
          <Select
            labelId="report-type-label"
            id="typeOfReport"
            name="typeOfReport"
            size="small"
            fullWidth
            value={formData?.typeOfReport}
            onChange={handleChange}
          >
            <MenuItem value="Consolidated">Consolidated</MenuItem>
            <MenuItem value="Facility">Facility</MenuItem>
          </Select>
          {errors?.typeOfReport && (
            <FormHelperText>{errors.typeOfReport}</FormHelperText>
          )}
        </Box>

        {formData?.typeOfReport === "Facility" ? (
          <Box>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", mb: 1, mt: 2 }}
            >
              Facility
            </Typography>
            <Select
              labelId="facility-label"
              id="facility"
              name="facility"
              size="small"
              fullWidth
              value={formData?.facility || "Select Facility"}
              onChange={handleChange}
              defaultValue=""
            >
              <MenuItem value="Select Facility" disabled>
                Select Facility
              </MenuItem>
              {facilities.map((facility) => (
                <MenuItem key={facility.value} value={facility.value}>
                  {facility.label}
                </MenuItem>
              ))}
            </Select>

            {errors?.facility && (
              <FormHelperText>{errors.facility}</FormHelperText>
            )}
          </Box>
        ) : null}

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100%",
          minHeight: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleExit}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {list()}
    </Drawer>
  );
};

export default AddGhg;
